import { render, staticRenderFns } from "./LicenseTypeDetailsGeneralData.vue?vue&type=template&id=686248c5&"
import script from "./LicenseTypeDetailsGeneralData.vue?vue&type=script&lang=js&"
export * from "./LicenseTypeDetailsGeneralData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports